import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Avatar from './Avatar';
import '../styles/Navbar.css';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleLogout = () => {
    logout();
    navigate('/');
    setDropdownOpen(false);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownOpen]);

  return (
    <nav className="navbar">
      <div className="container navbar-container">
        <Link to="/" className="navbar-brand">
          <h1 className="logo-text">Érzésre</h1>
        </Link>

        <ul className="navbar-menu">
          <li><Link to="/">Főoldal</Link></li>
          <li><Link to="/recipes">Receptek</Link></li>
          {user && <li><Link to="/my-recipes">Saját Receptek</Link></li>}
          <li><Link to="/cooking-school">Főzőiskola</Link></li>
          <li><Link to="/about">Rólam</Link></li>

          {user ? (
            <>
              <li><Link to="/add-recipe" className="btn btn-primary">+ Recept</Link></li>
              <li className="navbar-profile" ref={dropdownRef}>
                <div className="navbar-avatar-wrapper" onClick={toggleDropdown}>
                  <Avatar
                    name={user.name}
                    imageUrl={user.profileImage}
                    size="small"
                    clickable={true}
                  />
                </div>

                {dropdownOpen && (
                  <div className="navbar-dropdown">
                    <div className="navbar-dropdown-header">
                      <Avatar
                        name={user.name}
                        imageUrl={user.profileImage}
                        size="large"
                      />
                      <div className="navbar-dropdown-info">
                        <div className="navbar-dropdown-name">
                          {user.nickname || user.name}
                        </div>
                        <div className="navbar-dropdown-email">{user.email}</div>
                      </div>
                    </div>

                    <div className="navbar-dropdown-divider"></div>

                    <Link
                      to="/profile"
                      className="navbar-dropdown-item"
                      onClick={() => setDropdownOpen(false)}
                    >
                      <span className="navbar-dropdown-icon">👤</span>
                      Profilom
                    </Link>

                    <Link
                      to="/settings"
                      className="navbar-dropdown-item"
                      onClick={() => setDropdownOpen(false)}
                    >
                      <span className="navbar-dropdown-icon">⚙️</span>
                      Beállítások
                    </Link>

                    <Link
                      to="/my-recipes"
                      className="navbar-dropdown-item"
                      onClick={() => setDropdownOpen(false)}
                    >
                      <span className="navbar-dropdown-icon">📖</span>
                      Saját Receptek
                    </Link>

                    <Link
                      to="/favorites"
                      className="navbar-dropdown-item"
                      onClick={() => setDropdownOpen(false)}
                    >
                      <span className="navbar-dropdown-icon">⭐</span>
                      Kedvenceim
                    </Link>

                    {user.role === 'admin' && (
                      <>
                        <div className="navbar-dropdown-divider"></div>
                        <Link
                          to="/admin"
                          className="navbar-dropdown-item"
                          onClick={() => setDropdownOpen(false)}
                        >
                          <span className="navbar-dropdown-icon">🛡️</span>
                          Admin Panel
                        </Link>
                      </>
                    )}

                    <div className="navbar-dropdown-divider"></div>

                    <button
                      className="navbar-dropdown-item navbar-dropdown-logout"
                      onClick={handleLogout}
                    >
                      <span className="navbar-dropdown-icon">🚪</span>
                      Kijelentkezés
                    </button>
                  </div>
                )}
              </li>
            </>
          ) : (
            <>
              <li><Link to="/login" className="btn btn-outline">Bejelentkezés</Link></li>
              <li><Link to="/register" className="btn btn-primary">Regisztráció</Link></li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
